export const ENTERPRISE_FEATURE =
  "This feature is available in Enterprise subscription";
